import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretRight } from '@fortawesome/pro-solid-svg-icons/faCaretRight';
import React, { useCallback, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import classnames from 'clsx';

import { DropdownMenuItem } from '../dropdown-menu-item';
import { LockIconWithTooltip } from '../../../feature-gates/lock-icon-with-tooltip';

import style from './dropdown-menu-item-with-nested-menu.module.css';

// Matches max-width in dropdown-menu-item-with-nested-menu.module.css
const FLYOUT_MAX_WIDTH_PX = 385;

export const DropdownMenuItemWithNestedMenu = ({
  children = null,
  className = '',
  title,
  isLocked = false,
  isDisabled = false,
  // Internal props injected by parent DropdownMenu via cloneElement — forwarded to DropdownMenuItem
  hovered = false,
  index,
  onRowHover,
  dropdownMenuType,
}) => {
  const rowRef = useRef(null);
  const [openLeft, setOpenLeft] = useState(false);
  const classes = classnames(className, style['dropdown-menu-item']);
  const hasFlyout = !isLocked && !isDisabled;

  const detectOpenDirection = useCallback(() => {
    if (!rowRef.current) return;
    const rect = rowRef.current.getBoundingClientRect();
    setOpenLeft(rect.right + FLYOUT_MAX_WIDTH_PX > global.window.innerWidth);
  }, []);

  const flyoutClassName = classnames(style['dropdown-menu-items'], {
    [style['dropdown-menu-items-left']]: openLeft,
  });

  return (
    <div ref={rowRef} onMouseEnter={hasFlyout ? detectOpenDirection : undefined}>
      <DropdownMenuItem
        className={classes}
        disabled={isLocked || isDisabled}
        dropdownMenuType={dropdownMenuType}
        hovered={hovered}
        index={index}
        onRowHover={onRowHover}
      >
        <div className={style['dropdown-title']}>
          <div className={style['dropdown-title-name']}>{title}</div>
          <div
            className={classnames(style['dropdown-top-level-svg'], {
              [style['lock-icon-wrapper']]: isLocked,
            })}
          >
            {hasFlyout && <FontAwesomeIcon icon={faCaretRight} />}
            {isLocked && <LockIconWithTooltip iconClass={style['lock-icon']} />}
          </div>
          <div />
        </div>
        {hasFlyout && <div className={flyoutClassName}>{children}</div>}
      </DropdownMenuItem>
    </div>
  );
};

DropdownMenuItemWithNestedMenu.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  isLocked: PropTypes.bool,
  isDisabled: PropTypes.bool,
  hovered: PropTypes.bool,
  index: PropTypes.number,
  onRowHover: PropTypes.func,
  dropdownMenuType: PropTypes.string,
};
